import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

const ServiceCard = ({ title, description, icon, image, link, isContactCard, ctaText }) => {
  // Add a function to scroll to top when link is clicked
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  // Determine the text to display for the call-to-action
  const actionText = ctaText || (isContactCard ? 'Contact Us' : 'Learn More');

  return (
    <Card image={image}>
      <CardOverlay isContactCard={isContactCard} />
      <CardContent>
        <CardIcon>{icon}</CardIcon>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
        <CardLink to={link} onClick={handleClick}>
          <span>{actionText}</span>
          <FaArrowRight />
        </CardLink>
      </CardContent>
    </Card>
  );
};

const Card = styled.div`
  position: relative;
  height: 350px;
  border-radius: 8px;
  overflow: hidden;
  background-image: ${({ image }) => `url(${image})`};
  background-size: cover;
  background-position: center;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-10px);
    
    &::before {
      opacity: 0.8;
    }
  }
`;

const CardOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to top,
    rgba(19, 19, 19, 0.9) 0%,
    rgba(19, 19, 19, 0.5) 60%,
    rgba(19, 19, 19, 0.3) 100%
  );
  z-index: 1;
  
  ${({ isContactCard }) => isContactCard && `
    background: linear-gradient(
      to top,
      rgba(19, 19, 19, 0.95) 0%,
      rgba(19, 19, 19, 0.8) 60%,
      rgba(19, 19, 19, 0.7) 100%
    );
    border: 2px solid var(--color-secondary);
  `}
`;

const CardContent = styled.div`
  position: relative;
  z-index: 2;
  padding: 1.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const CardIcon = styled.div`
  font-size: 2.5rem;
  color: var(--color-secondary);
  margin-bottom: 1rem;
`;

const CardTitle = styled.h3`
  color: var(--color-tertiary);
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
`;

const CardDescription = styled.p`
  color: var(--color-tertiary);
  opacity: 0.8;
  margin-bottom: 1.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const CardLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--color-secondary);
  font-weight: 500;
  transition: var(--transition);
  
  &:hover {
    gap: 0.8rem;
  }
`;

export default ServiceCard; 